import {
  Box,
  Grid,
  GridColumn,
  Link,
  Logo,
  Target,
  Text,
  ThemeOverride
} from "@modernatx-internal/ui-kit-react";
import React from "react";

import { useExperience } from "@/hooks/useExperience";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";
import { useText } from "@/hooks/useText";
import { deleteGeoSelectedCookie, deleteHCPConfirmedCookie } from "@/utils/getCookieHelpers";

import { LanguageSelector } from "./LanguageSelector";

interface PageHeaderProps {
  variant?: "primary" | "minimal";
}

export const PageHeader: React.FC<PageHeaderProps> = ({ variant = "primary" }) => {
  const { getText } = useText();
  const { countryOptions } = useExperience();
  const { getLocalizedPath } = useLocalizedPath();
  const hasMultipleCountries = countryOptions.length > 1;
  const websiteReservedText = getText("WEBSITE_RESERVED_FOR_HEALTHCARE_PROVIDERS");

  const onChangeCountriesClick = React.useCallback(() => {
    deleteGeoSelectedCookie();
    deleteHCPConfirmedCookie();
  }, []);

  return (
    <>
      {websiteReservedText && variant === "primary" && (
        <ThemeOverride mode="dark">
          <Box
            sx={{
              backgroundColor: "surface-brand",
              // @ts-ignore
              "@media print": {
                display: "none"
              }
            }}
          >
            <Grid variant="uniform-12">
              <GridColumn>
                <Text as="p" weight="medium" sx={{ py: 4 }}>
                  {websiteReservedText}{" "}
                  {hasMultipleCountries && (
                    <Link
                      href={getLocalizedPath("/temperature-excursion", false)}
                      onClick={onChangeCountriesClick}
                      sx={{ textDecorationColor: "currentColor" }}
                    >
                      {getText("CHANGE_COUNTRIES")}
                    </Link>
                  )}
                </Text>
              </GridColumn>
            </Grid>
          </Box>
        </ThemeOverride>
      )}
      <Box sx={{ backgroundColor: "surface-neutral-default" }}>
        <Grid variant="uniform-12">
          <GridColumn
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              minHeight: 16,
              py: 4
            }}
          >
            {variant === "primary" ? (
              <Target href={getLocalizedPath("/temperature-excursion")} sx={{ display: "block" }}>
                <Logo logo="moderna-logo" sx={{ height: [6, 8] }} />
              </Target>
            ) : (
              <Logo logo="moderna-logo" sx={{ height: [6, 8] }} />
            )}
            {variant === "primary" && (
              <Box sx={{ marginInlineStart: "auto" }}>
                <LanguageSelector />
              </Box>
            )}
          </GridColumn>
        </Grid>
      </Box>
    </>
  );
};
